import { render, staticRenderFns } from "./support-ico.vue?vue&type=template&id=3e101e83&scoped=true"
import script from "./support-ico.vue?vue&type=script&lang=js"
export * from "./support-ico.vue?vue&type=script&lang=js"
import style0 from "./support-ico.vue?vue&type=style&index=0&id=3e101e83&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e101e83",
  null
  
)

export default component.exports